// ONE implementation, two runtimes — the same function objects the edge
// functions use, so the app and the server can never disagree about what a
// vendor is going to invoice. (Same pattern as packageBasis.js /
// vendorState.mjs / canonicalItemCost.mjs; do not add a browser copy.)
//
// The module is import-light on purpose: it reaches only packageBasis.mjs,
// which is itself import-free, so this re-export adds no bundle weight and no
// dependency on the Recipe Lab unit engine.
export {
  FULFILLMENT_MODELS,
  UNKNOWN_MODEL,
  ESTIMATED_MODELS,
  BILLING_BASIS_WARNINGS,
  collectBillingEvidence,
  packTextClaimsVariableWeight,
  resolveBillingBasis,
  estimateOrderCost,
  estimatedExtendedCost,
  billingBasisNeedsReview,
  planBillingBasisClassification,
  buildBuyDisplay,
  formatMoney,
  formatQuantity,
  formatUnitCount,
} from '../../../supabase/functions/_shared/billingBasis.mjs';
